module.exports = __webpack_public_path__ + "img/close-1.1bb6175f.svg";